var _rect, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProductinline = function SvgProductinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 45 45"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "#11D483",
    rx: 5.4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 3.125,
    fill: "#171A1C",
    stroke: "#171A1C",
    strokeWidth: 1.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M22.5 7.114c0-.615.5-1.118 1.113-1.076A16.5 16.5 0 1 1 6.038 23.613c-.042-.614.46-1.113 1.076-1.113.615 0 1.109.5 1.157 1.113A14.273 14.273 0 1 0 23.613 8.27c-.614-.048-1.113-.542-1.113-1.157"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M31.39 22.5c.648 0 1.18.527 1.105 1.17a10.062 10.062 0 1 1-11.163-11.162c.644-.076 1.17.456 1.17 1.104s-.528 1.163-1.168 1.262a7.716 7.716 0 1 0 8.795 8.795c.098-.64.614-1.169 1.262-1.169"
  })));
};
export default SvgProductinline;